import React from "react";
import { useSelector, useDispatch } from "react-redux";

function Loader() {
  const isActive = useSelector((state) => state.loader.isActive);
  return isActive ? (
    <div className="loader">
      <div className="loading-pulse load-icon"></div>
    </div>
  ) : null;
}

export default Loader;
